import { useTranslation } from "react-i18next";

import { CopyToClipboardText } from "@/blocks/CopyToClipboardText";
import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

import { useCall } from "@/hooks/useCall/useCall";

export function SectionCallUuid() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <Section data-test="call-uuid-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.call_uuid")}</SectionTitle>
      </SectionHeader>
      <CopyToClipboardText variant="filled">{call.uuid}</CopyToClipboardText>
    </Section>
  );
}
